import React, { Component } from 'react'

export default class Image extends Component {
  render (){
    const { style, className, src, title } = this.props
    return (
      <img style={ style } className={ className } src={ src } alt={ title } />
    )
  }
}

